import * as React from "react";
import { isNative as isNativeCheck } from "@origin-digital/platform-helpers";
import { KrakenAuthNav } from "@origin-digital/myaccount-navigation";
import { MasqueradeBanner } from "../Banner/MasqueradeBanner";
import { Header } from "../Header";
import { Navigation } from "../Navigation";
import { NoNavigationHeader } from "../Navigation/NoNavigationHeader";
import { Survey } from "../Survey";

interface BaseAppContentProps {
  actionBar?: Window["oetal"]["pageData"]["actionBar"];
  showHeader: Window["oetal"]["pageData"]["showHeader"];
  enableCrisisBanner: Window["oetal"]["pageData"]["enableCrisisBanner"];
  title: string;
}

export const UnauthAppContent: React.FC<BaseAppContentProps> = ({
  showHeader,
  actionBar = {},
  title,
  enableCrisisBanner = true,
}) => {
  return (
    <>
      {showHeader === true && <Navigation />}
      {showHeader === "scoped" && <NoNavigationHeader />}
      <Header
        title={actionBar.title || title}
        desktopVariant={actionBar.desktopVariant}
        component={actionBar.component}
        hideActionBar={actionBar.hidden}
        mobileNavButton={actionBar.mobileNavButton}
        breadcrumbs={actionBar.breadcrumbs}
        enableCrisisBanner={enableCrisisBanner}
      />
    </>
  );
};

export const KrakenAppContent: React.FC<BaseAppContentProps> = ({
  actionBar = {},
  showHeader,
  title,
  enableCrisisBanner = true,
}) => {
  return (
    <>
      <MasqueradeBanner />
      {showHeader && (
        <KrakenAuthNav desktopVariant={actionBar.desktopVariant} />
      )}

      <Header
        component={actionBar.component}
        hideActionBar={actionBar.hidden}
        desktopVariant={actionBar.desktopVariant}
        isNative={isNativeCheck()}
        mobileNavButton={actionBar.mobileNavButton}
        title={actionBar.title || title}
        breadcrumbs={actionBar.breadcrumbs}
        enableCrisisBanner={enableCrisisBanner}
      />
      <Survey />
    </>
  );
};
